import { createFileRoute } from '@tanstack/react-router';

import { ProjectDetailView } from '@/features/AssetDetailView/ProjectDetailView/ProjectDetailView';

export const Route = createFileRoute(
    '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/',
)({
    component: ProjectDetailView,
});
